export default defineAppConfig({
  ui: {
    modal:{
      container: 'flex min-h-full items-end sm:items-center justify-center text-center backdrop-blur-sm bg-white/60',
      overlay:{base:'bg-white/60 '}
    },
    // icons: ['material-symbols', 'hugeicons'],
    primary: 'almond-frost',
    gray: 'cool',
    strategy: 'override',
    input: {
      wrapper: 'relative',
      base: 'relative block w-full disabled:cursor-not-allowed disabled:opacity-75 focus:outline-none border-0 text-black',
      form: 'form-input',
      rounded: '',
      placeholder: 'placeholder-gray-400 dark:placeholder-gray-500',
      file: {
        base: 'file:cursor-pointer file:rounded-l-md file:absolute file:left-0 file:inset-y-0 file:font-medium file:m-0 file:border-0 file:ring-1 file:ring-gray-300 dark:file:ring-gray-700 file:text-gray-900 dark:file:text-white file:bg-gray-50 hover:file:bg-gray-100 dark:file:bg-gray-800 dark:hover:file:bg-gray-700/50',
        padding: {
          sm: 'ps-[96px]'
        }
      },
      size: {
        sm: 'text-lg'
      },
      gap: {
        sm: 'gap-x-1.5'
      },
      padding: {
        sm: 'px-0 py-1.5'
      },
      leading: {
        padding: {
          sm: 'ps-7'
        }
      },
      trailing: {
        padding: {
          sm: 'pe-9'
        }
      },
      icon: {
        base: 'flex-shrink-0 text-white dark:text-gray-500',
        color: 'text-{color}-500 dark:text-{color}-400',
        loading: 'animate-spin',
        size: {
          sm: 'h-6 w-6'
        },
        leading: {
          wrapper: 'absolute inset-y-0 start-0 flex items-center',
          pointer: 'pointer-events-none',
          padding: {
            sm: 'pr-2.5'
          }
        },
        trailing: {
          wrapper: 'absolute inset-y-0 end-0 flex items-center',
          pointer: 'pointer-events-none',
          padding: {
            sm: 'px-2.5'
          }
        }
      },
      color: {
        black: {
          outline: 'bg-white text-gray-900 border-black border-b focus:border-b-almond-frost-500 focus:ring-0'
        },
        white: {
          outline: 'bg-transparent text-white border-white border-b focus:border-b-almond-frost-500 focus:ring-0'
        }
      },
      variant: {
        outline: 'bg-transparent text-gray-900 dark:text-white',
        none: 'bg-transparent focus:ring-0 focus:shadow-none'
      },
      default: {
        size: 'sm',
        color: 'white',
        variant: 'outline',
        loadingIcon: 'i-heroicons-arrow-path-20-solid'
      }
    },
    textarea: {
      wrapper: 'relative',
      base: 'relative block w-full disabled:cursor-not-allowed disabled:opacity-75 focus:outline-none border-0 text-black',
      form: 'form-input',
      rounded: '',
      placeholder: 'placeholder-gray-400 dark:placeholder-gray-500',
      file: {
        base: 'file:cursor-pointer file:rounded-l-md file:absolute file:left-0 file:inset-y-0 file:font-medium file:m-0 file:border-0 file:ring-1 file:ring-gray-300 dark:file:ring-gray-700 file:text-gray-900 dark:file:text-white file:bg-gray-50 hover:file:bg-gray-100 dark:file:bg-gray-800 dark:hover:file:bg-gray-700/50',
        padding: {
          sm: 'ps-[96px]'
        }
      },
      size: {
        sm: 'text-lg'
      },
      gap: {
        sm: 'gap-x-1.5'
      },
      padding: {
        sm: 'px-0 py-1.5'
      },
      leading: {
        padding: {
          sm: 'ps-7'
        }
      },
      trailing: {
        padding: {
          sm: 'pe-9'
        }
      },
      icon: {
        base: 'flex-shrink-0 text-white dark:text-gray-500',
        color: 'text-{color}-500 dark:text-{color}-400',
        loading: 'animate-spin',
        size: {
          sm: 'h-6 w-6'
        },
        leading: {
          wrapper: 'absolute inset-y-0 start-0 flex items-center',
          pointer: 'pointer-events-none',
          padding: {
            sm: 'pr-2.5'
          }
        },
        trailing: {
          wrapper: 'absolute inset-y-0 end-0 flex items-center',
          pointer: 'pointer-events-none',
          padding: {
            sm: 'px-2.5'
          }
        }
      },
      color: {
        black: {
          outline: 'bg-white text-gray-900 border-black border-b focus:border-b-almond-frost-500 focus:ring-0'
        },
        white: {
          outline: 'bg-transparent text-white border-white border-b focus:border-b-almond-frost-500 focus:ring-0'
        }
      },
      variant: {
        outline: 'bg-transparent text-gray-900 dark:text-white',
        none: 'bg-transparent focus:ring-0 focus:shadow-none'
      },
      default: {
        size: 'sm',
        color: 'white',
        variant: 'outline',
        loadingIcon: 'i-heroicons-arrow-path-20-solid'
      }
    },
    button: {
      base: 'focus:outline-none focus-visible:outline-0 disabled:cursor-not-allowed disabled:opacity-75 flex-shrink-0',
      font: 'font-medium uppercase',
      rounded: 'rounded-full',
      truncate: 'text-left break-all line-clamp-1',
      block: 'w-full flex justify-center items-center',
      inline: 'inline-flex items-center',
      size: {
        sm: 'text-lg'
      },
      gap: {
        sm: 'gap-x-1.5'
      },
      padding: {
        sm: 'px-16 py-4'
      },
      color: {
        black: {
          outline: 'border-2 border-black hover:bg-black hover:text-white disabled:bg-transparent disabled:text-black focus-visible:ring-2 focus-visible:ring-black hover:bg-black transition-all duration-200'
        }
      },
      variant: {
        outline: 'ring-2 ring-inset ring-current text-{color}-500 hover:bg-{color}-50 disabled:bg-transparent focus-visible:ring-2 focus-visible:ring-{color}-500 hover:bg-{color}-500'
      },
      default: {
        size: 'sm',
        variant: 'outline',
        color: 'black',
        loadingIcon: 'i-heroicons-arrow-path-20-solid'
      }
    },
    select: {
      wrapper: 'relative',
      base: 'relative block w-full disabled:cursor-not-allowed disabled:opacity-75 focus:outline-none border-0 ring-0 focus:ring-0 bg-primary',
      form: 'form-select',
      rounded: '',
      placeholder: 'text-gray-400 dark:text-gray-500',
      size: {
        sm: 'text-lg'
      },
      gap: {
        sm: 'gap-x-1.5'
      },
      padding: {
        sm: 'px-0 py-1.5'
      },
      leading: {
        padding: {
          sm: 'ps-9'
        }
      },
      trailing: {
        padding: {
          sm: 'pe-9'
        }
      },
      color: {
        white: {
          outline: 'bg-brand-gray border-0 border-b border-white focus:border-almond-frost-500 text-white'
        }
      },
      variant: {
        outline: ''
      },
      default: {
        size: 'sm',
      //   color: 'white',
      //   variant: 'outline',
        loadingIcon: 'i-heroicons-arrow-path-20-solid',
        trailingIcon: 'i-heroicons-chevron-down-20-solid'
      }
    },
    checkbox: {
      wrapper: 'relative flex items-start',
      container: 'flex items-center h-6',
      base: 'h-[19px] w-[19px] dark:checked:bg-current dark:checked:border-transparent dark:indeterminate:bg-current dark:indeterminate:border-transparent disabled:opacity-50 disabled:cursor-not-allowed focus:ring-0 focus:ring-transparent focus:ring-offset-transparent',
      form: 'form-checkbox',
      rounded: '',
      color: 'text-{color}-500 dark:text-{color}-400',
      background: 'bg-transparent',
      border: 'border border-white dark:border-gray-700',
      ring: 'focus-visible:ring-2 focus-visible:ring-{color}-500 dark:focus-visible:ring-{color}-400 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-gray-900',
      inner: 'ms-3 flex flex-col',
      label: 'text-lg font-medium text-white',
      required: 'text-lg text-red-500 dark:text-red-400',
      help: 'text-lg text-gray-500 dark:text-gray-400',
      default: {
        color: 'primary'
      }
    }
  }
})
